import React from "react";
import styles from "./styles.module.scss";

const Loading = () => {
  return (
    <div className="h-screen flex items-center justify-center">
      <div className={styles["lds-facebook"]}>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loading;
